<template>
  <div class="item" id="cardInfo.id" v-on:click="clickCard">
    <div class="img-box">
      <el-image :src="preUrl+cardInfo.logo" class="card-img" fit="contain" style="width: 300px"></el-image>
    </div>
    <div class="info-ch">
      <h6 class="ellipsis">{{cardInfo.titlealt}}</h6>
    </div>
  <div class="info-en">
    <h6 class="ellipsis">{{cardInfo.infoEn}}</h6>
  </div>

  </div>
</template>
<script>
  export default {
    props: [
      'cardInfo',
      'url',
      'preUrl'
    ],
    methods: {
      clickCard () {
        let paramer = {menuidparent: this.cardInfo.menuidparent, menuidchild: this.cardInfo.menuidchild, voice: this.cardInfo.voice, mp4: this.cardInfo.mp4, numbers: this.cardInfo.mediaid}
        this.$router.push({
          name: this.url,
          query: paramer
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  @import "../assets/style/mixin";

  .item {
    cursor:pointer;
    background-color: #ecf3f6;
    margin-bottom: 10px;
    padding: 10px 10px 10px 10px;
    display: flex;
    flex-direction: column;
    position: relative;
    height: 200px;
    text-align: center;
    .img-box {
      margin-bottom: 1rem;
      @extend %block-center;
      transition: 1s;
      -moz-transition: 1s; /* Firefox 4 */
      -webkit-transition: 1s; /* Safari and Chrome */
      -o-transition: 1s; /* Opera */
    }
    .info-ch {
      width: 100%;
      padding: 0 10px;
      h6 {
        overflow: hidden;
        font-size: 14px;
        line-height: 1.2;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #808285;
        letter-spacing: 3px;
      }
    }
    .info-en {
      width: 100%;
      padding: 0 20px;
      h6 {
        overflow: hidden;
        font-size: 14px;
        font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI", "Microsoft YaHei", "微软雅黑", sans-serif;
        letter-spacing: 0.5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #808285;
      }
    }
  }
  .img-box:hover{
    transform:scale(1.1, 1.1);
    -ms-transform:scale(1.1, 1.1); 	/* IE 9 */
    -moz-transform:scale(1.1, 1.1); 	/* Firefox */
    -webkit-transform:scale(1.1, 1.1); /* Safari 和 Chrome */
    -o-transform:scale(1.1, 1.1);
  }
  .item:hover .ellipsis{
    color: #3A5FCD;
    transform:scale(1.1, 1.1);
    -ms-transform:scale(1.1, 1.1); 	/* IE 9 */
    -moz-transform:scale(1.1, 1.1); 	/* Firefox */
    -webkit-transform:scale(1.1, 1.1); /* Safari 和 Chrome */
    -o-transform:scale(1.1, 1.1);
  }
</style>



// WEBPACK FOOTER //
// playcard2.vue?c4a2c04a